import request from "@/utils/request";

export function getJobsList(params = {}) {
  return request({
    method: "get",
    url: "/jobs/list/",
    data: params
  });
}

export function getJobDetail(params = {},id) {
  return request({
    method: "get",
    url: `/jobs/${id}/detail/`,
    data: params
  });
}

export function jobsMark(params = {}) {
  return request({
    method: "post",
    url: "/jobs/mark/",
    data: params
  });
}

